import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface PollsHeaderProps {
  countryName?: string;
  currentIndex?: number;
  totalPolls?: number;
  onRefresh?: () => void;
}

const PollsHeader: React.FC<PollsHeaderProps> = ({
  countryName,
  currentIndex,
  totalPolls,
  onRefresh,
}) => {
  return (
    <div className="mb-6 flex-1 pt-[16px]">
      {/* Poll Count Display (if applicable) */}
      {currentIndex !== undefined && totalPolls !== undefined && (
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium">
            Poll {currentIndex + 1} of {totalPolls}
          </h2>
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
            >
              Refresh
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PollsHeader;
